export const DEFAULT_ROUTE_NAME = "New Route";

export function nextDefaultRouteName(existingNames: readonly string[]): string {
  const used = new Set(
    existingNames.map((name) => name.trim()).filter((name) => name.length > 0)
  );

  if (!used.has(DEFAULT_ROUTE_NAME)) {
    return DEFAULT_ROUTE_NAME;
  }

  let suffix = 2;
  while (used.has(`${DEFAULT_ROUTE_NAME} ${suffix}`)) {
    suffix += 1;
  }

  return `${DEFAULT_ROUTE_NAME} ${suffix}`;
}
